import type { ReactNode } from "react";
import { clsx } from "../../utils/clsx";
import * as styles from "./Container.css";

type ContainerProps = {
  children: ReactNode;
  narrow?: boolean;
  className?: string;
};

export function Container({ children, narrow = false, className }: ContainerProps) {
  return (
    <div className={clsx(narrow ? styles.narrow : styles.container, className)}>
      {children}
    </div>
  );
}
